import React, { useState, useEffect, useRef, useContext } from "react"
import { Form, Input, Select, InputNumber } from "antd"
import { getPcodeDict } from "@/utils/dataStorage"
const { Option } = Select
const EditableContext = React.createContext()
const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm()
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    )
}

const EditableCell = ({ title, editable, children, dataIndex, record, handleSave, ...restProps }) => {
    const [editing, setEditing] = useState(false)
    const inputRef = useRef()
    const form = useContext(EditableContext)
    useEffect(() => {
        if (editing) {
            inputRef.current.focus()
        }
    }, [editing])

    const toggleEdit = () => {
        setEditing(!editing)
        form.setFieldsValue({
            [dataIndex]: record[dataIndex],
        })
    }

    const save = async (e, status) => {
        try {
            const values = await form.validateFields()
            if (values.serviceNature && values.serviceNature === "016001") {
                values.threeGuaranteesUnit = "10601"
            }
            toggleEdit()
            handleSave({ ...record, ...values }, status)
        } catch (errInfo) {
            console.log("数据保存失败", errInfo)
        }
    }

    const inputTypes = (str, record) => {
        //看是否是编辑物料    是物料， 服务性质只展示 三包和收费
        let isPart = record.materialCode ? true : false

        //看服务性质是否选择三包， 选中三包才可以， 才可触发三包选择框
        let isSelectThree = record.serviceNature !== "016001" ? true : false

        //三包是否有选项，选中三包没有优惠和折扣，不是三包可以选择折扣
        let isThreeBag = record.threeGuaranteesUnit ? true : false

        //服务性质
        if (str === "serviceNature") {
            return isPart ? (
                <Select
                    ref={inputRef}
                    onChange={(e) => {
                        save(e, "serviceNature")
                    }}
                    onBlur={(e) => {
                        save(e, "serviceNature")
                    }}
                >
                    {getPcodeDict("016").children.map((item) => {
                        // if (item.dictCode !== "016003" && item.dictCode !== "016004") {
                        if (item.dictCode === "016001" || item.dictCode === "016002") {
                            return (
                                <Option value={item.dictCode} key={item.id}>
                                    {item.title}
                                </Option>
                            )
                        }
                    })}
                </Select>
            ) : (
                <Select ref={inputRef} onChange={save} onBlur={save}>
                    {getPcodeDict("016").children.map((item) => (
                        <Option value={item.dictCode} key={item.id}>
                            {item.title}
                        </Option>
                    ))}
                </Select>
            )
        }
        //三包单位
        else if (str === "threeGuaranteesUnit") {
            return (
                <Select ref={inputRef} onChange={save} onBlur={save} disabled={isSelectThree}>
                    {getPcodeDict("106").children.map((item) => (
                        <Option value={item.dictCode} key={item.id}>
                            {item.title}
                        </Option>
                    ))}
                </Select>
            )
        }
        //预付款
        else if (str === "prepayFlag") {
            return (
                <Select ref={inputRef} onChange={save} onBlur={save}>
                    <Option value={0} key={0}>
                        否
                    </Option>
                    <Option value={1} key={1}>
                        是
                    </Option>
                </Select>
            )
        }
        //工时,数量
        else if (str === "workHour") {
            return <InputNumber ref={inputRef} step={1} precision={1} onBlur={save} />
        }
         //工时,数量
         else if (str === "materialNumber") {
            return <InputNumber ref={inputRef} step={1} onBlur={save} />
        }
        //项目单价，物料单价
        else if (str === "hourPrice" || str === "unitPrice") {
            return <InputNumber ref={inputRef} min={0} formatter={(value) => `¥${value}`} parser={(value) => value.replace("¥", "")} onBlur={save} />
        }
        //优惠
        else if (str === "preferentialAmount") {
            return (
                <InputNumber ref={inputRef} formatter={(value) => `¥${value}`} parser={(value) => value.replace("¥", "")} onBlur={save} />
            )
        }
        //折扣
        else if (str === "discount" || str === "materialDiscount") {
            return <InputNumber ref={inputRef} min={1} max={10} step={1} onBlur={save} />
        } else if (str === "claimNumber") {
            return <Input ref={inputRef} onPressEnter={save} onBlur={save} disabled={isSelectThree} />
        } else {
            return <Input ref={inputRef} onPressEnter={save} onBlur={save} />
        }
    }
    const inputRules = (str) => {
        if (str === "hourPrice" || str === "unitPrice" || str === "preferentialAmount") {
            return [
                {
                    required: true,
                    message: `数值不可为空`,
                },
                {
                    pattern: /^[0-9]+(.[0-9]{0,2})?$/,
                    message: "请输入数字且可保留两位小数",
                },
            ]
        } else if (str === "materialNumber") {
            return [
                { required: true, message: "请输入数量" },
                {
                    validator: (rule, value, callback) => {
                        if (record && record.remainingNum < value) {
                            callback(`数量不能大于${record.remainingNum}`)
                        } else {
                            callback()
                        }
                    },
                },
            ]
        } else if (str === "workHour") {
            return [
                { required: true, message: "请输入工时" },
                {
                    validator: (rule, value, callback) => {
                        if (record && record.maxWorkHour && record.maxWorkHour < value) {
                            callback(`数量不能大于${record.maxWorkHour}`)
                        } else {
                            callback()
                        }
                    },
                },
            ]
        }
    }
    let childNode = children
    if (editable) {
        childNode = editing ? (
            <Form.Item
                style={{
                    margin: 0,
                }}
                name={dataIndex}
                rules={inputRules(dataIndex)}
            >
                {inputTypes(dataIndex, record)}
            </Form.Item>
        ) : (
            <div className="editable-cell-value-wrap" onClick={toggleEdit}>
                {children}
            </div>
        )
    }

    return <td {...restProps}>{childNode}</td>
}

export { EditableRow, EditableCell }
